import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    changeWarrantyInitialState,
    handlePaginationStateWarranty,
    updateFiltersWarranty,
    resetFiltersWarranty,
    setSelectedWarranty,
    setShowWarrantyDetails,
} from "../../../store/warranty/warrantySlice";

const mapStateToProps = (state) => {
    return {
        // warranty
        formType: state.warranty.formTypeWarranty,
        initialValues: state.warranty.initialValuesWarranty,
        showDrawer: state.warranty.showDrawerWarranty,
        pagination: state.warranty.paginationWarranty,
        filters: state.warranty.filtersWarranty,
        selectedWarranty: state.warranty.selectedWarranty,
        showWarrantyDetails: state.warranty.showWarrantyDetails,
    };
};

const mapDispatch = {
    changeWarrantyInitialState,
    handlePaginationState: handlePaginationStateWarranty,
    updateFilters: updateFiltersWarranty,
    resetFilters: resetFiltersWarranty,
    setSelectedWarranty,
    setShowWarrantyDetails,
};

const mapDispatchToProps = (dispatch) => bindActionCreators(mapDispatch, dispatch);

const Store = (Container) => connect(mapStateToProps, mapDispatchToProps)(Container);

export default Store;
